export enum FrameworkClassType {
  Robot = 'robot',
  Mechanism = 'mechanism',
  Electronic = 'electronic',
  /** Static actions (e.g. `UtilityActions.print_to_screen_action(...)`) not tied to a hardware instance. */
  Utility = 'utility',
}

export enum FrameworkClassPartType {
  Motors = 'motors',
  Sensors = 'sensors',
  Other = 'other',
}
